/**
 * @generated SignedSource<<f117d1ccc1419e3dd9c69b242a0222e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutGuestBuyerQueryRenderer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptionsQueryRenderer_viewer" | "CheckoutMobilePageHeader_viewer" | "CheckoutPageHeader_viewer" | "checkoutRelayAction_viewer" | "useAuth_viewer">;
  readonly " $fragmentType": "CheckoutGuestBuyerQueryRenderer_viewer";
};
export type CheckoutGuestBuyerQueryRenderer_viewer$key = {
  readonly " $data"?: CheckoutGuestBuyerQueryRenderer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutGuestBuyerQueryRenderer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutGuestBuyerQueryRenderer_viewer",
  "selections": [
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CheckoutPageHeader_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptionsQueryRenderer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAuth_viewer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutRelayAction_viewer",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutTransactionReducer_viewer",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "chargeCurrencies",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CurrencyConversionRateEvent",
              "kind": "LinkedField",
              "name": "currentRates",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutShippingReducer_viewer",
          "selections": [
            {
              "condition": "hasSessionUserGeoInfo",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RegionalInfo",
                  "kind": "LinkedField",
                  "name": "regionalInfo",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "zipCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ]
            }
          ],
          "args": null,
          "argumentDefinitions": [
            {
              "kind": "RootArgument",
              "name": "hasSessionUserGeoInfo"
            }
          ]
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CheckoutMobilePageHeader_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a3ee4795602779cb28cf72f37ca057d9";

export default node;
